import { Link } from "react-router-dom";

/**
 * 404 catch-all. Any path that does not match a defined route lands here.
 * Deliberately dead-ends the old `/cp/*` channel-partner routes.
 */
export default function NotFound() {
  return (
    <div className="min-h-[calc(100vh-140px)] bg-offwhite grid place-items-center px-5">
      <div className="max-w-md text-center space-y-4">
        <div className="font-display text-forest text-6xl md:text-8xl leading-none">404</div>
        <h1 className="font-display text-forest text-2xl md:text-3xl leading-tight">
          Nothing lives at this address.
        </h1>
        <p className="text-forest/70 text-sm leading-relaxed">
          The page you were looking for has moved, retired, or never existed.
          Head back to Pali Hill City and let the ridge take it from here.
        </p>
        <div className="pt-2">
          <Link to="/" className="btn-primary text-sm">
            Return to the homepage
          </Link>
        </div>
      </div>
    </div>
  );
}
